import { inject, Injectable, Injector } from '@angular/core';
import { handleRequestError } from '@softline/application';
import {
  ApiDataAccess,
  ApiResourceLocation,
  Dictionary,
  ReadonlyHttpApiRepository,
} from '@softline/core';
import {
  SOFTLINE_API_CONSTRUCTION_PARTS,
  SOFTLINE_API_CONSTRUCTION_PARTS_SUBMIT,
} from '../construction-parts.api';
import { ConstructionPart } from '../models/construction-part';
import { ConstructionPartQuery } from '../models/construction-part-query';
import { ConstructionPartUpdate } from '../models/construction-part-update';

@Injectable()
export class ConstructionPartRepository extends ReadonlyHttpApiRepository<
  ConstructionPart | undefined,
  ConstructionPartQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_CONSTRUCTION_PARTS);
  }

  readonly injector = inject(Injector);

  override getLoadPathParams(params: ConstructionPartQuery): Dictionary<unknown> {
    return { id: params.id };
  }

  override async load(
    params: ConstructionPartQuery
  ): Promise<ConstructionPart | undefined> {
    const location: ApiResourceLocation = {
      path: this.path,
      queryParams: this.getLoadQueryParams(params),
      pathParams: this.getLoadPathParams(params),
    };
    const payload = this.getLoadPayload(params);
    try {
      return await this.dataAccess.get(location, payload);
    } catch (e) {
      handleRequestError(e, this.injector, { show: true });
      return new Promise<ConstructionPart | undefined>((resolve) => resolve(undefined));
    }
  }

  async update(value: ConstructionPartUpdate): Promise<ConstructionPart> {
    return await this.dataAccess.patch(
      {
        path: this.path,
        pathParams: { id: value.objectId },
      },
      value
    );
  }
  async submit(value: ConstructionPart, orderId: number): Promise<ConstructionPart> {
    return await this.dataAccess.create(
      {
        path: SOFTLINE_API_CONSTRUCTION_PARTS_SUBMIT,
        pathParams: { id: orderId },
      },
      value
    );
  }
}
